<div class="card border-0 bg-light-light mb-5">
    <div class="row no-gutters">
        <div  class="col-md-3 newsImg">
            <img  #newsImageId [src]="ImageData" alt="news-photo-02" style="object-fit:fill ;">
        </div>
        <div class="col-md-9" (click)="goToNews(newsitemView.news.id)">
            <div class="card-body">
                <p class="card-text"><small class="text-muted bg-white px-2 py-1">{{newsitemView.news.publishStateDate.toString() |date :'HH:mm yyyy LLL dd'}}</small></p>
                <a href="javascript:void(0)">
                    <h5 class="card-title mb-6"  style=" white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display:block;">{{newsitemView.news.newsTitle}}</h5>
                </a>
                <p class="card-text" [innerHtml]="newsitemView.news.newsBody"
                    style=" white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display:block;max-height: 30px">
                    </p>
            </div>
        </div>
    </div>
</div>
